export const FORM_NAME = 'MemberMailchimpSubscribeModal'
